interface IEnv {
  NODE_ENV: string;
  REACT_APP_API_URL: string;
  REACT_APP_SAMBA_PH: string;
  REACT_APP_PLATFORM_URL: string;
  REACT_APP_COOKIE_NAME: string;
  REACT_APP_COOKIE_DOMAIN: string;
  REACT_APP_KIRA_WIDGET_URL: string;
  REACT_APP_KIRA_LEVEL_ID: string;
}

const getEnv = (key: keyof IEnv): string => {
  const value = process.env[key];
  if (value === undefined) {
        console.log(`Environment variable ${key} is not defined`);
  }
  return value ?? '';
};

const env: IEnv = {
  NODE_ENV: getEnv('NODE_ENV'),
  REACT_APP_API_URL: getEnv('REACT_APP_API_URL'),
  REACT_APP_SAMBA_PH: getEnv('REACT_APP_SAMBA_PH'),
  REACT_APP_PLATFORM_URL: getEnv('REACT_APP_PLATFORM_URL'),
  REACT_APP_COOKIE_NAME: getEnv('REACT_APP_COOKIE_NAME'),
  REACT_APP_COOKIE_DOMAIN: getEnv('REACT_APP_COOKIE_DOMAIN'),
  REACT_APP_KIRA_WIDGET_URL:
    'https://kira-widget.s3.us-east-1.amazonaws.com/kira-widget.umd.cjs',
  REACT_APP_KIRA_LEVEL_ID: getEnv('REACT_APP_KIRA_LEVEL_ID') || '5b2186ec9c5aa43084ff7d08',
};

export default env;
